import { gql } from '@apollo/client';

const insurance = {
  INSURANCE: gql`
    fragment Insurance on InsuranceResult {
      estimation {
        policy {
          type
          money {
            amount
            currency
          }
        }
        noClaimsDiscount
        dateOfBirth
        age
      }
      displayBlock
    }
  `,
};
export default insurance;
